<template>
  <div class="start">
    <Icon></Icon>
    <el-collapse-transition>
      <Error v-if="errorShow" :msg="errorMsg" v-on:closeErrorTip="closeErrorTip"></Error>
    </el-collapse-transition>
    <Titles></Titles>
    <Inputs :type="'account'" style="margin-top: 45px;" v-on:inputText="getAccount" v-on:enterInput="enterInput"></Inputs>
    <Buttons ref=btn :type="'continue'" style="margin-bottom: 100px;" :data="account" v-on:openErrorTip="openErrorTip"></Buttons>
  </div>
</template>

<script>
  import Icon from '../components/Icon'
  import Error from '../components/Error'
  import Titles from '../components/Title'
  import Inputs from '../components/Inputs'
  import Buttons from '../components/Buttons'
  import { errorFn } from '../common/ErrorMsg.js'
  import { inviteRedirect } from '../common/Common.js'
  export default {
    data () {
      return {
        errorShow: false,
        errorMsg: '',
        account: '' // 输入的账号
      }
    },
    components: {
      Icon, Error, Titles, Inputs, Buttons
    },
    beforeCreate () {
      inviteRedirect(this)
    },
    mounted () {
    },
    beforeRouteEnter (from, to, next) {
      next(vm => {
        if (from.query['source'] === 'website' && from.query['account'] && to.name === null) {
          setTimeout(() => {
            vm.$refs.btn.clickBtn()
          }, 0)
        }
      })
    },
    methods: {
      getAccount (data) {
        this.account = data
        this.exist = false
      },
      // 关闭错误提示
      closeErrorTip () {
        errorFn.closeErrorTip(this)
      },
      // 弹出错误提示
      openErrorTip (msg) {
        errorFn.openErrorTip(msg, this)
      },
      // 输入框回车点击
      enterInput () {
        this.$refs.btn.clickBtn()
      }
    }
  }
</script>

<style lang="less" scoped>
  @import '../../assets/css/_mixin.less';
  .start {
    .white-bg();
    min-height: 420px;
    margin-top: -210px;
  }
</style>



// WEBPACK FOOTER //
// Start.vue?312ec34c